/**
@ngdoc directive
@name groupValidation

@description
Group validation for checkboxes - at least one checkbox needs to be required.

@example
Please take a look at testUi (former testValidation) page for an example.
*/
(function () {
  var groupValidation = function ($compile, $timeout, formFieldFactory) {
    return {
      restrict: "A",
      scope: true,
      bindToController: {
        ngRequired: "=",
        // groupValidation passed Object for deprecated multi select checkboxes
        // { (key): true, (key): false, (key): true, ... }
        // groupValidation passed a boolean for <xf:multi2 /> _multiSelectField2.gsp
        groupValidation: "=",
      },
      priority: -1, // in order to work with xms-validation on the same wrapping tag
      controller: function () {},
      controllerAs: "ctrl",
      template: function (tElement, tAttrs) {
        tElement.find("[name]").each(function () {
          // add ng-required based on model
          $(this).attr("ng-required", "ctrl.ngRequired && !valid");
          // $( this ).attr("ng-change","someSelected("+tAttrs.groupValidation+")");
          // the above have been replaced with model watch now
        });
      },
      replace: false,
      transclude: false,
      require: ["^form", "groupValidation"],
      link: function (scope, el, attrs, ctrls) {
        var ctrl = ctrls[1];

        $timeout(function () {
          // needs timeout to let it work inside ng-repeat

          scope.someSelected(ctrl.groupValidation); // run once on link (without triggerDependantFieldValidation on init)

          // the watch instead of ng-change on checkbox will allow validation on external model changes...
          // (although ng-change version was more performant...)
          scope.$watchCollection(
            function () {
              return ctrl.groupValidation;
            },
            function (newVal, oldVal) {
              if (newVal != oldVal) {
                scope.someSelected(newVal);
              }
            }
          );

          scope.$watchCollection(
            function () {
              return ctrl.ngRequired;
            },
            function (newVal, oldVal) {
              if (newVal != oldVal) {
                ctrl.ngRequired = newVal;
                scope.someSelected(ctrl.groupValidation);
              }
            }
          );

          // the same watch, but need to be run only once and then unregistered
          var runOnce = scope.$watchCollection(
            function () {
              return ctrl.groupValidation;
            },
            function (newVal, oldVal) {
              if (newVal != oldVal) {
                var form = ctrls[0];
                var fieldName = el.find("[name]").attr("name");
                formFieldFactory.triggerDependantFieldValidation(
                  form[fieldName],
                  0
                );
                runOnce(); // unregister watch
              }
            }
          );
        });

        // main validation function in here
        // it checkes if any of the checkboxes been checked
        scope.someSelected = function (object) {
          if (!ctrl.ngRequired || ctrl.ngRequired === "false") {
            scope.valid = true; // always valid if not required, just for performance as it's checked already with ng-required
            return;
          }
          if (object) {
            if (typeof object === "boolean") {
              scope.valid = object;
            } else {
              scope.valid = Object.keys(object).some(function (key) {
                return object[key];
              });
            }
          } else {
            scope.valid = false;
          }
        };
      },
    };
  };
  groupValidation.$inject = ["$compile", "$timeout", "formFieldFactory"];
  angular.module("app").directive("groupValidation", groupValidation);
})();
